/**
 * Alerta inline para janela de 24h expirada no Instagram Direct
 * 
 * Exibido acima da área de input quando a janela de 24h do Instagram
 * está expirada. Diferente do WhatsApp, o Instagram NÃO possui templates
 * para reabrir conversa, portanto o chat fica completamente bloqueado.
 * 
 * O contato precisa enviar uma nova mensagem para reabrir a janela.
 */

import { AlertTriangle, Instagram } from 'lucide-react';

export function InstagramSessionExpiredAlert() {
  return (
    <div className="flex items-center gap-3 px-4 py-3 mb-2 rounded-lg bg-destructive/10 border border-destructive/20">
      <div className="flex items-center gap-2 text-sm text-destructive">
        <AlertTriangle className="h-4 w-4 flex-shrink-0" />
        <div className="flex flex-col gap-0.5">
          <span className="font-medium">
            Janela de 24h expirada
          </span>
          <span className="text-xs text-muted-foreground">
            Não é possível enviar mensagens Direct até o contato responder novamente. Para responder comentários, clique em "Responder" no comentário desejado.
          </span>
        </div>
      </div>
    </div>
  );
}
